// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8b91cfa4d38a375c0a65","655":"e7fee72639c47846be35"}[chunkId] + ".js";
};